import React, { useEffect, useState } from "react";
import Breadcrumb from "../common/breadcrum";
import styles from "./../../assets/styles/_topics.module.scss";
import { useNavigate } from "react-router-dom";
import { getTopics } from "../../api/topic";
import dayjs from "dayjs";
import { LoadingSpin } from "../LoadingSpin";

const TopicsComponent = () => {
  const navigate = useNavigate();

  const data = [
    // {
    //   thummb: slide,
    //   time: "2024.11.21",
    //   desc: "大西流星さん出演のWEBCM公開中！対象のヘアケア商品のご購入でYOLUオリジナルグッズをプレゼント！",
    // },
    // {
    //   thummb: slide,
    //   time: "2024.11.14",
    //   desc: "毎年大人気の夜桜をイメージした YOLUの春 限定にボディソープ、バスタブレットが初登 場！「サクラナイトシリーズ」を11月27日よ り発売",
    // },
    // {
    //   thummb: slide,
    //   time: "2024.10.29",
    //   desc: "【楽天市場ランキング6冠*】YOLUの“夜間美 容ボディケアシリーズ”が大好評！「ドリー ミング バスタブレット」が週間ランキング1 位、「ナイトケアボディソープ」も発売初日 デイリーランキング1位を獲得",
    // },
    // {
    //   thummb: slide,
    //   time: "2024.9.3",
    //   desc: "「BOTANIST」と「YOLU」からミニチュア シャンプーボトルの「ガシャポン®」が初登 場！9月より全国で順次発売開始",
    // },
    // {
    //   thummb: slide,
    //   time: "2024.9.2",
    //   desc: "YOLUがポップアップイベントを開催！幻想 的なパステルカラーの足湯と新登場のボディ ソープ＆ミルクを体験できる『NIGHT BEAUTY LABO ～ YOLUゆ ～』オープン",
    // },
    // {
    //   thummb: slide,
    //   time: "2024.7.30",
    //   desc: "YOLUから“夜間美容ボディケア”が誕生。 「重炭酸*1バスタブレット」と「濃密保湿の ボディソープ＆ボディミルク」を新発売",
    // },
    // {
    //   thummb: slide,
    //   time: "2024.6.14",
    //   desc: "YOLUが「100万人のキャンドルナイト＠増 上寺 2024」に初出展",
    // },
    // {
    //   thummb: slide,
    //   time: "2024",
    //   desc: "大西流星さん出演のWEBCM公開中！対象のヘアケア商品のご購入でYOLUオリジナルグッズをプレゼント！",
    // },
    // {
    //   thummb: slide,
    //   time: "2024",
    //   desc: "大西流星さん出演のWEBCM公開中！対象のヘアケア商品のご購入でYOLUオリジナルグッズをプレゼント！",
    // },
    // {
    //   thummb: slide,
    //   time: "2024",
    //   desc: "大西流星さん出演のWEBCM公開中！対象のヘアケア商品のご購入でYOLUオリジナルグッズをプレゼント！",
    // },
    // {
    //   thummb: slide,
    //   time: "2024",
    //   desc: "大西流星さん出演のWEBCM公開中！対象のヘアケア商品のご購入でYOLUオリジナルグッズをプレゼント！",
    // },
    // {
    //   thummb: slide,
    //   time: "2024",
    //   desc: "大西流星さん出演のWEBCM公開中！対象のヘアケア商品のご購入でYOLUオリジナルグッズをプレゼント！",
    // },
    // {
    //   thummb: slide,
    //   time: "2024",
    //   desc: "大西流星さん出演のWEBCM公開中！対象のヘアケア商品のご購入でYOLUオリジナルグッズをプレゼント！",
    // },
    // {
    //   thummb: slide,
    //   time: "2024",
    //   desc: "大西流星さん出演のWEBCM公開中！対象のヘアケア商品のご購入でYOLUオリジナルグッズをプレゼント！",
    // },
    // {
    //   thummb: slide,
    //   time: "2024",
    //   desc: "大西流星さん出演のWEBCM公開中！対象のヘアケア商品のご購入でYOLUオリジナルグッズをプレゼント！",
    // },
    // {
    //   thummb: slide,
    //   time: "2024",
    //   desc: "大西流星さん出演のWEBCM公開中！対象のヘアケア商品のご購入でYOLUオリジナルグッズをプレゼント！",
    // },
    // {
    //   thummb: slide,
    //   time: "2024",
    //   desc: "大西流星さん出演のWEBCM公開中！対象のヘアケア商品のご購入でYOLUオリジナルグッズをプレゼント！",
    // },
    // {
    //   thummb: slide,
    //   time: "2024",
    //   desc: "大西流星さん出演のWEBCM公開中！対象のヘアケア商品のご購入でYOLUオリジナルグッズをプレゼント！",
    // },
    // {
    //   thummb: slide,
    //   time: "2024",
    //   desc: "大西流星さん出演のWEBCM公開中！対象のヘアケア商品のご購入でYOLUオリジナルグッズをプレゼント！",
    // },
  ];

  const itemsPerPage = 9;

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const [topics, setTopics] = useState([]);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  useEffect(() => {
    const getData = async () => {
      setIsLoading(true);
      try {
        const topics = await getTopics(currentPage, itemsPerPage);
        setTopics(topics.contents);
        setTotalPages(Math.ceil(topics.totalCount / itemsPerPage));
      } catch (error) {
        alert("トピックの取得に失敗しました");
      } finally {
        setIsLoading(false);
      }
    }
    getData();
  }, [currentPage, itemsPerPage]);

  return (
    <div className={styles.topics}>
      <div className={styles.topicsTitle}>TOPICS</div>
      {topics.length > 0 && !isLoading && (
        <div className={`${styles.list} data-grid`}>
          {topics.map((item, index) => (
            <div
              key={index}
              className={`${styles.item} data-item`}
              onClick={() => navigate(`/topic-detail/${item.id}`)}
            >
              <img src={item.thumbnail.url} alt="topic" />
              <div className={`${styles.topicTime} topic-time`}>{dayjs(item.publishedAt).format("YYYY.MM.DD")}</div>
              <div className={`${styles.topicTime} topic-desc`}>{item.title}</div>
            </div>
          ))}
        </div>
      )}
      {isLoading && <LoadingSpin />}
      {topics.length === 0 && !isLoading && <p style={{ textAlign: "center", color: "#fff", fontSize: "20px", fontWeight: "bold" }}>まだ記事はありません。</p>}

      {/* Phân trang */}
      <div className={`${styles.pagination} pagination`}>
        <span>
          {currentPage} / {totalPages}
        </span>

        <div className={`${styles.pageButtonContainer} page-button`}>
          {currentPage > 1 && (
            <button onClick={() => handlePageChange(currentPage - 1)}>
              <div className={styles.previosButton}></div>
            </button>
          )}
          {[...Array(totalPages)].map((_, index) => (
            <button
              key={index}
              className={`${styles.pageButton} ${currentPage === index + 1 ? styles.active : ""
                }`}
              onClick={() => handlePageChange(index + 1)}
            >
              {index + 1}
            </button>
          ))}

          {/* Nút chuyển trang > */}
          {currentPage < totalPages && (
            <button onClick={() => handlePageChange(currentPage + 1)}>
              <div className={styles.nextButton}></div>
            </button>
          )}
        </div>
      </div>
      <Breadcrumb
        data={[
          {
            title: "TOP",
            link: "/",
          },
          {
            title: "TOPICS",
            link: "/topics",
          },
        ]}
      />
    </div>
  );
};

export default TopicsComponent;
